import React from 'react'
import ReactDOM from 'react-dom'
import HeaderApp from '../applications/components/HeaderApp'
import ProductsCategoryApp from '../applications/components/ProductsCategoryApp'
import {
    componentExistsOnPage,
    getComponentProps,
    getRootElement,
} from '../applications/utils/ssr'

if (componentExistsOnPage('HeaderApp')) {
    const props = getComponentProps('HeaderApp')

    ReactDOM.hydrate(<HeaderApp {...props} />, getRootElement('HeaderApp'))
}

const props = getComponentProps('ProductsCategoryApp')

ReactDOM.hydrate(<ProductsCategoryApp {...props} />, getRootElement('ProductsCategoryApp'))
